import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

const waNumber = (p) => (p || "").replace(/[^\d]/g, "").replace(/^00/, "");

export default function QuoteActions({ quote }) {
  const [phone, setPhone] = useState("");
  const [saving, setSaving] = useState(false);
  const save = async () => {
    setSaving(true);
    try {
      await api.post("/quotes", { ...quote, client_phone: phone });
      toast.success("Preventivo salvato nello storico");
    } catch (e) { toast.error(formatApiError(e)); }
    setSaving(false);
  };
  const sendWa = async () => {
    await save();
    window.open(`https://api.whatsapp.com/send?phone=${waNumber(phone)}&text=${encodeURIComponent(quote.script)}`, "_blank");
  };
  return (
    <div className="mt-3 flex flex-wrap items-center gap-2" data-testid="quote-actions">
      <input data-testid="quote-phone" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Telefono cliente (es. +39 333 1234567)"
        className="flex-1 min-w-[200px] border border-blue-200 rounded-lg px-3 py-2 text-sm bg-white" />
      <button data-testid="quote-send-wa" onClick={sendWa} disabled={saving} className="px-4 py-2 rounded-lg text-sm font-semibold bg-green-600 text-white hover:bg-green-700">
        📲 Invia su WhatsApp
      </button>
      <button data-testid="quote-save" onClick={save} disabled={saving} className="px-4 py-2 rounded-lg text-sm font-semibold border border-blue-300 text-blue-700 bg-white hover:bg-blue-50">
        💾 Salva nello storico
      </button>
      <div className="w-full text-[11px] text-gray-500">"Invia su WhatsApp" salva anche il preventivo nello storico. Senza numero si apre WhatsApp e scegli tu il contatto.</div>
    </div>
  );
}
